import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Input } from '@packages/shared/src/ui/Input/Input';

const messages = defineMessages({
  serviceCount: {
    id: 'Aplus.serviceCount',
    defaultMessage: 'Anzahl',
  },
});

const minimum = 1;

const getSanitizedValue = (value: number | string, min: number, max: number | null) => {
  let parsedValue: number;
  try {
    parsedValue = parseInt(value as string, 10);
  } catch {
    parsedValue = min;
  }
  if (parsedValue < min) {
    parsedValue = min;
  }
  if (max && parsedValue > max) {
    parsedValue = max;
  }
  return parsedValue;
};

export const AplusServiceCountTextField: React.FC<{
  count: number;
  maximum: number | null;
  onChange: (count: number) => void;
}> = ({ count, maximum, onChange }) => {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState<number>(() => getSanitizedValue(count, minimum, maximum));

  const onChangeHandler = (newValue: string) => {
    const parsedValue = getSanitizedValue(newValue, minimum, maximum);
    // set the value and trigger onchange (backend call)
    setValue(parsedValue);
    onChange(parsedValue);
  };

  return (
    <Input
      type="number"
      label={formatMessage(messages.serviceCount)}
      value={value}
      onChange={(e) => onChangeHandler(e.target.value)}
      min={minimum}
      max={maximum ?? undefined}
    />
  );
};
